/* generated from backend OpenAPI -- do not edit */
import type { JSONSchema } from 'zod/v4/core';
export const schema = {
  "type": "object",
  "properties": {
    "type": {
      "type": "string",
      "enum": [
        "subscribe.communications.v1"
      ]
    },
    "topics": {
      "maxItems": 50,
      "type": "array",
      "items": {
        "type": "string",
        "pattern": "^communications\\.(funnel|conversation)\\.[1-9]\\d*$",
        "description": "Communications realtime topic"
      }
    },
    "token": {
      "type": "string",
      "minLength": 1
    }
  },
  "required": [
    "type",
    "topics",
    "token"
  ],
  "x-browser-runtime-schema": true
} satisfies JSONSchema.JSONSchema;
